import { render, staticRenderFns } from "./FormCheckBox.vue?vue&type=template&id=8cfe3f48&scoped=true&"
import script from "./FormCheckBox.vue?vue&type=script&lang=js&"
export * from "./FormCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./FormCheckBox.vue?vue&type=style&index=0&id=8cfe3f48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfe3f48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
